import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'search',
        (state.get('search') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'search',
        (state.get('search') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state, { customers }) {
    return state
        .set(
            'search',
            (state.get('search') || Map())
                .set('list', fromJS(customers))
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('search', Map());
}
